import { HeaderStyle } from '../../models/enum';
import { IPrintConfiguration } from '../../services/helpers';

export function convertHeaderStyle(printConfiguration: IPrintConfiguration) {
    if (!printConfiguration?.headerStyle) {
        printConfiguration.headerStyle = HeaderStyle.Default;
        if (printConfiguration.isHiddenHeader) {
            printConfiguration.headerStyle = HeaderStyle.None;
        } else {
            if (printConfiguration.isCompactHeader) {
                printConfiguration.headerStyle = HeaderStyle.Compact;
            }
        }
    }
}